export default "__VITE_ASSET__DPrREom1__"